import { render, staticRenderFns } from "./RewardProducts.vue?vue&type=template&id=0c9965dc"
import script from "./RewardProducts.vue?vue&type=script&lang=js"
export * from "./RewardProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports